export function sanitizeContent(content: string) {
  const regex = new RegExp(
    `:(?!4D\\.\\w+)[CPK]?\\d+(?=(?:[^"{}\\[\\]\\\\]*(?:\\\\.|"(?:[^"{}\\[\\]\\\\]*\\\\.)*[^"{}\\[\\]\\\\]*"))*[^"}\\]]*$)`,
    'gm',
  );

  return (
    content
      // Check this solution: https://stackoverflow.com/questions/6462578/regex-to-match-all-instances-not-inside-quotes
      .replace(regex, '')
  );
}
